import { render, staticRenderFns } from "./Keyword.vue?vue&type=template&id=fe826e2a&scoped=true"
import script from "./Keyword.vue?vue&type=script&lang=ts"
export * from "./Keyword.vue?vue&type=script&lang=ts"
import style0 from "./Keyword.vue?vue&type=style&index=0&id=fe826e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe826e2a",
  null
  
)

export default component.exports